import { MyHealer } from '../../core/models/my-healer';
import { extractMessageFromError } from '../../infra/adapters/luminara/common/ErrorUtil';

export interface ClientRebookState {
  healer?: MyHealer;
  loadingDataError?: string;
  selectedHealerPackageId?: string;
  showHealerPackagesListScreen: boolean;
  remindMeClicked: boolean;
  clientFirstName?: string;
  skipRebookScreen: boolean;
  showRebookPackageDetailsPopup: boolean;
}

export const initialClientRebookState = () =>
  ({
    healer: undefined,
    loadingDataError: undefined,
    showHealerPackagesListScreen: false,
    remindMeClicked: false,
    skipRebookScreen: false,
    showRebookPackageDetailsPopup: false,
  } as ClientRebookState);

export interface RebookScreenDataPayload {
  shouldSkipRebookScreen: boolean;
  myHealerData?: MyHealer;
}
export interface ClientRebookAction {
  type:
    | 'LOAD_REBOOK_SCREEN_DATA_SUCCESS'
    | 'LOAD_REBOOK_SCREEN_DATA_FAILURE'
    | 'SET_SELECTED_HEALER_PACKAGE'
    | 'SET_SHOW_HEALER_PACKAGES'
    | 'SET_REMIND_ME_CLICKED'
    | 'SET_CLIENT_FIRST_NAME'
    | 'RESET'
    | 'SHOW_REBOOK_PACKAGE_DETAILS_POPUP'
    | 'HIDE_REBOOK_PACKAGE_DETAILS_POPUP';
  payload?: any;
}

const clientRebookReducer = (state: ClientRebookState = initialClientRebookState(), action: ClientRebookAction): ClientRebookState => {
  switch (action.type) {
    case 'LOAD_REBOOK_SCREEN_DATA_SUCCESS': {
      const payload = action.payload as RebookScreenDataPayload;
      return {
        ...state,
        healer: payload.myHealerData,
        skipRebookScreen: payload.shouldSkipRebookScreen,
      };
    }
    case 'LOAD_REBOOK_SCREEN_DATA_FAILURE':
      return { ...state, loadingDataError: extractMessageFromError(action.payload) };
    case 'SET_SELECTED_HEALER_PACKAGE': {
      const selectedHealerPackageId = action.payload;
      return {
        ...state,
        selectedHealerPackageId: selectedHealerPackageId,
      };
    }
    case 'SET_SHOW_HEALER_PACKAGES': {
      return {
        ...state,
        showHealerPackagesListScreen: action.payload,
        selectedHealerPackageId: undefined,
      };
    }
    case 'SET_REMIND_ME_CLICKED': {
      return { ...state, remindMeClicked: action.payload };
    }
    case 'SET_CLIENT_FIRST_NAME': {
      return { ...state, clientFirstName: action.payload };
    }
    case 'RESET': {
      return initialClientRebookState();
    }
    case 'SHOW_REBOOK_PACKAGE_DETAILS_POPUP': {
      return {
        ...state,
        showRebookPackageDetailsPopup: true,
      };
    }
    case 'HIDE_REBOOK_PACKAGE_DETAILS_POPUP': {
      return {
        ...state,
        showRebookPackageDetailsPopup: false,
      };
    }
    default:
      return state;
  }
};

export default clientRebookReducer;
